import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderBy'
})
export class OrderByPipe implements PipeTransform {
  private sortAsc: (a: any, b: any) => number;
  private sortDesc: (a: any, b: any) => number;

  // returns a sorted copy of an array of objects, sorted by a property, in ascending (default) or descending order
  transform(array: any[], property: string, direction: 'asc' | 'desc' = 'asc'): any {

    if (!array || !property) return array;

    // sort function by string property
    if (typeof array[0][property] === 'string' || array[0][property] instanceof String) {
      this.sortAsc = (a, b) => a[property].localeCompare(b[property]);
      this.sortDesc = (b, a) => a[property].localeCompare(b[property]);
    // sort function by number property
    } else {
      this.sortAsc = (a, b) => a[property] - b[property];
      this.sortDesc = (b, a) => a[property] - b[property];
    }

    // return sorted copy of array
    return direction === 'asc' ? [...array].sort(this.sortAsc) : [...array].sort(this.sortDesc);
  }
}
